import { ComponentStyles } from "types/common";

export const styles: ComponentStyles = {
  visibleMeasurementModalContainer: {
    scale: 1,
    translateY: 0,
    opacity: 1,
    pointerEvents: "auto",
  },
  textField: {
    "& input[type=number]": {
      MozAppearance: "textfield",
      appearance: "textfield",
      borderRadius: 5,
    },
    "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
      {
        WebkitAppearance: "none",
        margin: 0,
      },
  },
  textField__input: {
    // padding: "0.5rem",
    borderRadius: 5,
    // paddingBlock: 1,
  },
  buttonWrapper: {
    display: "flex",
    flexDirection: "row",
    gap: 1,
    justifyContent: "center",
  },
};

export const measurementModalContainer = (show: boolean) => ({
  position: "absolute",
  // width: {
  //   xs: "40vw",
  //   sm: "35vw",
  //   md: "30vw",
  //   lg: "25vw",
  // },
  width: "max-content",
  maxWidth: "45vw",
  bottom: 5,
  left: "50%",
  transform: "translateX(-50%)",
  padding: 3,
  backgroundColor: "background.paper",
  borderRadius: 5,
  zIndex: 1,
  gap: 2,
  // hidden styles
  scale: show ? 1 : 0,
  translateY: show ? 0 : 50,
  opacity: show ? 1 : 0,
  pointerEvents: show ? "auto" : "none",
  display: show? "block":"none",
});
